import { useTranslation } from 'react-i18next';
import { beforeAfterImages } from '@/mocks/salonData';

interface BeforeAfterItem {
  label: string;
  desc: string;
}

export default function BeforeAfterGallery() {
  const { t } = useTranslation();
  const message = encodeURIComponent(t('whatsapp.message'));
  const items = t('beforeAfter.items', { returnObjects: true }) as BeforeAfterItem[];

  return (
    <section id="gallery" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-champagne-600 text-xs font-medium tracking-[0.2em] uppercase mb-3">
            {t('beforeAfter.title')}
          </p>
          <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-dark-950 mb-3">
            {t('beforeAfter.title')}
          </h2>
          <p className="text-dark-500 text-base md:text-lg max-w-xl mx-auto">
            {t('beforeAfter.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-cream-50 border border-dark-100 transition-all hover:border-champagne-300 hover:shadow-lg"
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={beforeAfterImages[i + 1]}
                  alt={item.label}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block bg-champagne-500 text-dark-950 text-xs font-bold px-3 py-1 rounded-full mb-2">
                    {item.label}
                  </span>
                  <p className="text-white/80 text-sm">{item.desc}</p>
                </div>
              </div>
              <div className="p-4">
                <a
                  href={`https://wa.me/905313459987?text=${message}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 w-full border border-dark-200 text-dark-700 py-2.5 rounded-full text-sm font-medium hover:bg-dark-950 hover:text-white hover:border-dark-950 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line" />
                  {t('beforeAfter.contact')}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
